import { jsx } from 'panel';
import { QueryEntrySectionEl } from 'common/widgets/query-entry-section';
import { RowLabelType } from 'common/widgets/query-entry-section/types';
export function template() {
  var _a;

  return jsx("div", {
    sel: '.cohorts-literal-new'
  }, jsx(QueryEntrySectionEl, {
    attrs: {
      'row-limit': 1,
      'row-label-type': RowLabelType.None,
      'row-draggable': true,
      entries: this.state.entry ? [this.state.entry] : [],
      'track-name': "cohorts-qb",
      // enables per-line cohort filters
      'allow-cohort-filter': true,
      // TODO: data groups need to be checked for as a feature flag
      'data-group-id': (_a = this.attr("data-group-id")) !== null && _a !== void 0 ? _a : "",
      'data-groups-enabled': true,
      // TODO: figure out with Safdar if we can enable this now
      'disable-first-time-event-filters': true,
      // TODO: people plan access needs to be checked for
      // 'is-blocked-people': false,
      'project-has-people': true,
      // TODO: inline cohorts need to be disabled in the context of the cohorts qb
      'project-has-cohorts': true,
      'include-custom-properties': "all",
      'project-id': this.attr("project-id"),
      'workspace-id': this.attr("workspace-id"),
      'user-id': this.attr("user-id"),
      'project-as-of-date': this.attr("project-as-of-date")
    },
    on: {
      // TODO(pablo): forces a re-query, not sure if this is still relevant
      savedCustomEvent: null,
      // TODO(pablo): figureout how to define tracking
      track: null,
      // TODO(shawn): integrate literal updates
      update: ev => this.helpers.handleSectionUpdate(ev)
    }
  }));
}